import { apiRequest } from './client'
import { DstListing } from './admin'

export interface MarketplaceListingFilters {
  sponsor?: string
  asset_class?: string
  min_return?: number
  max_return?: number
  page?: number
  limit?: number
}

export interface MarketplaceListingsResponse {
  listings: DstListing[]
  total: number
  page: number
  limit: number
}

export const marketplaceApi = {
  async listListings(filters?: MarketplaceListingFilters): Promise<MarketplaceListingsResponse> {
    const searchParams = new URLSearchParams()
    if (filters?.sponsor) searchParams.set('sponsor', filters.sponsor)
    if (filters?.asset_class) searchParams.set('asset_class', filters.asset_class)
    if (filters?.min_return !== undefined) searchParams.set('min_return', String(filters.min_return))
    if (filters?.max_return !== undefined) searchParams.set('max_return', String(filters.max_return))
    if (filters?.page !== undefined) searchParams.set('page', String(filters.page))
    if (filters?.limit !== undefined) searchParams.set('limit', String(filters.limit))
    const qs = searchParams.toString()
    return apiRequest<MarketplaceListingsResponse>(
      `/marketplace/listings${qs ? `?${qs}` : ''}`,
      { auth: false }
    )
  },

  async getListing(id: string): Promise<DstListing> {
    const data = await apiRequest<{ listing: DstListing }>(
      `/marketplace/listings/${id}`,
      { auth: false }
    )
    return data.listing
  },
}
